import { DatePipe } from '@angular/common';
import { provideHttpClient, withInterceptors, withXsrfConfiguration } from '@angular/common/http';
import { importProvidersFrom, inject, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { bootstrapApplication, BrowserModule } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withHashLocation } from '@angular/router';
import { provideImpersonate } from '@sl/sl-angular-library';
import { routes } from './app/app-routes';
import { AppComponent } from './app/app.component';
import { ERole } from './app/core/enums/roles.enum';
import { InjectorContainerModule } from './app/core/injector-container/injector-container.module';
import { authenticationInterceptor } from './app/core/interceptors/auth/auth.interceptor';
import { loadingInterceptor } from './app/core/interceptors/loading/loading-interceptor';
import { RoleService } from './app/core/services/roles.service';
import { UserService } from './app/core/services/user.service';
import { DialogConfig } from './app/shared/components/dialog/dialog-config';
import { DialogRef } from './app/shared/components/dialog/dialog-ref';

function initializeApp(roleService: RoleService) {
  return () => roleService.loadRoles();
}

const impersonate_config =  {
  userService: UserService,
  historyKey:'shepherdsImpersonateHistory',
  switchUserRole:ERole.SHEPHERDS_SWITCH_USER as string
};

bootstrapApplication(AppComponent, {
    providers: [
        provideZoneChangeDetection(),
        importProvidersFrom(BrowserModule, InjectorContainerModule),
        provideAppInitializer(() => {
            const initializerFn = (initializeApp)(inject(RoleService));
            return initializerFn();
        }),
        { provide: DialogConfig, useClass: DialogConfig },
        { provide: DialogRef, useClass: DialogRef },
        { provide: DatePipe, useClass: DatePipe },
        provideHttpClient(withInterceptors([loadingInterceptor, authenticationInterceptor]), withXsrfConfiguration({cookieName: 'CSRF-TOKEN', headerName: 'X-CSRF-TOKEN'})),
        provideAnimations(),
        provideRouter(routes, withHashLocation()),
        provideImpersonate(impersonate_config)
    ]
})
  .catch(err => console.error(err));
